import {ProfiControlUserDto} from "./ProfiControlUserDto";
import {ProfiControlUserError, Roles} from "../Enums"

export class ProfiControlUser {
    public profiControlUserModel: ProfiControlUserDto;

    public UserName: string | undefined = '';
    public Password: string | undefined = '';
    public PasswordConfirmation: string | undefined = '';    
    public FirstName: string | undefined = '';
    public LastName: string | undefined = '';
    public Description: string | undefined = '';
    public IsSystemUser: boolean | undefined = false;
    public Role: Roles | Roles = Roles.None;
    public Error: ProfiControlUserError = ProfiControlUserError.None;

    public CertificateId: number | undefined = undefined;
    public CertificateDownloadLink: string | undefined = '';
    public HasCertificateError:boolean = false;

    public IsDummy: boolean = true;

    constructor(profiControlUser?: ProfiControlUserDto) {
        this.IsDummy = false;

        this.profiControlUserModel = !!profiControlUser ? profiControlUser : new ProfiControlUserDto();

        this.UserName = this.profiControlUserModel.userName;
        this.Password = this.profiControlUserModel.password === undefined ? '' : this.profiControlUserModel.password;
        this.FirstName = this.profiControlUserModel.firstName;
        this.LastName = this.profiControlUserModel.lastName;
        this.Description = this.profiControlUserModel.description;
        this.IsSystemUser = this.profiControlUserModel.isSystemUser;
        this.PasswordConfirmation = this.profiControlUserModel.password;
        this.Role = this.profiControlUserModel.role;
        this.CertificateId = this.profiControlUserModel.certificateId;
        
    }

    public Reset() {
        this.UserName = this.profiControlUserModel.userName;
        this.Password = this.profiControlUserModel.password;
        this.FirstName = this.profiControlUserModel.firstName;
        this.LastName = this.profiControlUserModel.lastName;
        this.Description = this.profiControlUserModel.description;
        this.IsSystemUser = this.profiControlUserModel.isSystemUser;
        this.PasswordConfirmation = this.profiControlUserModel.password;
        this.Role = this.profiControlUserModel.role;
        this.ResetModelErrors();
    }
    
    public ResetModelErrors(){
        this.HasCertificateError = false;
        this.Error = ProfiControlUserError.None;
    }
    
    public ResetDownloadToken(){
        this.CertificateDownloadLink = undefined;
    }

    get HasChanges() {
        return !this.IsDummy
            && (this.profiControlUserModel.id == undefined
                || this.UserName !== this.profiControlUserModel.userName
                || this.Password !== this.profiControlUserModel.password
                || this.FirstName !== this.profiControlUserModel.firstName
                || this.LastName !== this.profiControlUserModel.lastName
                || this.Description !== this.profiControlUserModel.description
                || this.IsSystemUser !== this.profiControlUserModel.isSystemUser
                || this.Role !== this.profiControlUserModel.role);
    }

    public GetModel() {
        let model = new ProfiControlUserDto();

        model.id = this.profiControlUserModel.id;
        model.userName = this.UserName;
        model.password = this.Password;
        model.firstName = this.FirstName;
        model.lastName = this.LastName;
        model.description = this.Description;
        model.certificateId = this.CertificateId;
        model.role = this.Role;
        return model;
    }

    get IsNew() {
        return this.profiControlUserModel.id === undefined;
    }

    get Id() {
        return this.profiControlUserModel.id;
    }

    public SetValues(proficontrolUserDto : ProfiControlUserDto) {
        this.profiControlUserModel = proficontrolUserDto;
        
        this.UserName = proficontrolUserDto.userName;
        this.Password = proficontrolUserDto.password;
        this.FirstName = proficontrolUserDto.firstName;
        this.LastName = proficontrolUserDto.lastName;
        this.Description = proficontrolUserDto.description;
        this.CertificateId = proficontrolUserDto.certificateId;
        this.Role = proficontrolUserDto.role;
    }

    public static CreateDummy() {
        let dummy = new ProfiControlUser();
        dummy.IsDummy = true;
        return dummy;
    }
}
